import { Box } from '@mui/material';
import React from 'react';
import FAQView from '../../components/faq/FAQView';
import StyledSection from '../../components/styles/StyledSection';
import { StyledHeading } from '../../components/styles/styles';
import FAQAdminEditPanel from './FAQAdmin/FAQAdminEditPanel';
import FAQAdminGroupsList from './FAQAdmin/FAQAdminGroupsList';
import FAQAdminToolbar from './FAQAdmin/FAQAdminToolbar';
import { useFAQAdmin } from './FAQAdmin/useFAQAdmin';

const FAQAdmin: React.FC = () => {
  const admin = useFAQAdmin();

  return (
    <StyledSection tone="default" noSidePaddingFrom="xs" noTopPadding key={admin.refreshKey}>
      <StyledHeading
        tone="default"
        component="h1"
        fontSize="1.75rem"
        fontWeight={600}
        sx={{ mb: 2 }}
      >
        FAQ Editor
      </StyledHeading>

      <FAQAdminToolbar
        onAddGroup={admin.addGroup}
        onSave={admin.saveToBucket}
        onReloadFromBucket={admin.reloadFromBucket}
        onRevertToPublished={admin.revertToPublished}
        onDownload={admin.downloadFromBucket}
        onClearBucket={admin.clearFromBucket}
      />

      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', minHeight: '50vh' }}>
        <FAQAdminGroupsList
          data={admin.data}
          selectedGroup={admin.selectedGroup}
          selectedItem={admin.selectedItem}
          onSelectGroup={admin.setSelectedGroup}
          onSelectItem={admin.setSelectedItem}
          onMoveGroup={admin.moveGroup}
          onRemoveGroup={admin.removeGroup}
          onUpdateGroupName={admin.updateGroupName}
          onAddItem={admin.addItem}
          onMoveItem={admin.moveItem}
          onRemoveItem={admin.removeItem}
        />

        <FAQAdminEditPanel
          data={admin.data}
          selectedGroup={admin.selectedGroup}
          selectedItem={admin.selectedItem}
          currentGroup={admin.currentGroup}
          currentItem={admin.currentItem}
          onUpdateItemQuestion={admin.updateItemQuestion}
          onUpdateItemAnswer={admin.updateItemAnswer}
          setInsertAnswer={admin.setInsertAnswer}
          imageHelperOpen={admin.imageHelperOpen}
          setImageHelperOpen={admin.setImageHelperOpen}
          imageHelperTab={admin.imageHelperTab}
          setImageHelperTab={admin.setImageHelperTab}
          assetAlt={admin.assetAlt}
          setAssetAlt={admin.setAssetAlt}
          publicAssetList={admin.publicAssetList}
          publicAssetFilter={admin.publicAssetFilter}
          setPublicAssetFilter={admin.setPublicAssetFilter}
          loadPublicAssetManifest={admin.loadPublicAssetManifest}
          apiImages={admin.apiImages}
          loadApiImages={admin.loadApiImages}
          desiredFileName={admin.desiredFileName}
          setDesiredFileName={admin.setDesiredFileName}
          selectedUploadFile={admin.selectedUploadFile}
          setSelectedUploadFile={admin.setSelectedUploadFile}
          uploading={admin.uploading}
          setUploading={admin.setUploading}
          handleUploadImage={admin.handleUploadImage}
          insertAnswer={admin.insertAnswer}
          faqLinkOpen={admin.faqLinkOpen}
          setFaqLinkOpen={admin.setFaqLinkOpen}
          faqLinkGroup={admin.faqLinkGroup}
          setFaqLinkGroup={admin.setFaqLinkGroup}
          faqLinkQuestion={admin.faqLinkQuestion}
          setFaqLinkQuestion={admin.setFaqLinkQuestion}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <StyledHeading headerVariant="heading2">Live Preview</StyledHeading>
        <FAQView data={admin.data} />
      </Box>
    </StyledSection>
  );
};

export default FAQAdmin;
